import { render, staticRenderFns } from "./video-animation.vue?vue&type=template&id=a469df70&scoped=true&"
import script from "./video-animation.vue?vue&type=script&lang=js&"
export * from "./video-animation.vue?vue&type=script&lang=js&"
import style0 from "./video-animation.vue?vue&type=style&index=0&id=a469df70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a469df70",
  null
  
)

export default component.exports